import fetch from '@/utils/fetch'

// 獲取dada基本訊息
export function getDadaInfo(params = {}) {
  return fetch({
    url: '/company/dada/info',
    method: 'get',
    params: params
  })
}
